import React, { Component } from "react";
import { Navbar, Button } from "@blueprintjs/core";
import { navigate } from "../../store/navigation/operations";
import CustomIcon from "../../components/CustomIcon";
import { Person, Notifications, Sms } from "@material-ui/icons/";
import { connect } from "react-redux";
import { hasNewNotifications } from "../../store/app_notifications/selectors";
import { hasUnreadConversations } from "../../store/messaging/selectors";
export class MobileNavbar extends Component {
  render() {
    let dashboardClass = this.props.currentPage === "/dashboard" ? "nav-link selected" : "nav-link";
    let messagesClass = this.props.currentPage === "/messages" ? "nav-link selected" : "nav-link";
    if (this.props.hasUnreadConversations) {
      messagesClass += " has-notification";
    }
    let notificationsClass = this.props.currentPage === "/notifications" ? "nav-link selected" : "nav-link";
    if (this.props.hasNewNotifications) {
      notificationsClass += " has-notification";
    }
    let myAccountClass = this.props.currentPage === "/my-account" ? "nav-link selected" : "nav-link";
    return (
      <div className="mobile-navbar-wrapper">
        <div className="mobile-navbar-spacer" />
        <Navbar className="auth-mobile-navbar">
          <Button onClick={(_) => this.props.navigate("/dashboard")} className={dashboardClass}>
            <CustomIcon name="owning-circle" size="24" className="icon" />
          </Button>

          <Button onClick={(_) => this.props.navigate("/notifications")} className={notificationsClass}>
            <Notifications className="icon" />
          </Button>

          <Button onClick={(_) => this.props.navigate("/messages")} className={messagesClass}>
            <Sms className="icon" />
          </Button>

          <Button onClick={(_) => this.props.navigate("/my-account")} className={myAccountClass}>
            <Person className="icon" />
          </Button>
        </Navbar>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    locale: state.i18n.locale,
    currentPage: state.router.location.pathname,
    hasUnreadConversations: hasUnreadConversations(state),
    hasNewNotifications: hasNewNotifications(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  navigate: (to) => dispatch(navigate(to)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileNavbar);
